import React from "react";
import santaGif from "../../../Assets/videos/Santa-Clause-Sleigh.gif";

export default function SantaFlyover() {
  return (
    <div className="santa-video-flyover">
      <div className="santa-banner">
        Merry Christmas from the Software Development Team
      </div>
      <img src={santaGif} alt="Santa Flyover" className="santa-gif" />
    </div>
  );
}
